import { ModelBase } from "@shoothill/core";
import * as MobX from "mobx";
import { IsNotEmpty } from "class-validator";

export class RegisterUserDetailsModel extends ModelBase<RegisterUserDetailsModel, RegisterUserDetailsModel> {
    @MobX.observable
    public age: number | string = "";

    @MobX.observable
    public companyName: string = "";

    @MobX.observable
    public position: string = "";

    @MobX.observable
    public companyWebsite: string = "";

    @MobX.observable
    public companyRegNo: string = "";

    @MobX.observable
    public companyVatNo: string = "";

    @MobX.observable
    @IsNotEmpty({ message: "Address 1 is required" })
    public address1: string = "";

    @MobX.observable
    public address2: string = "";

    @MobX.observable
    public city: string = "";

    @MobX.observable
    public county: string = "";

    @MobX.observable
    @IsNotEmpty({ message: "Postcode is required" })
    public postCode: string = "";

    @MobX.observable
    @IsNotEmpty({ message: "Gender is required" })
    public gender: string = "";

    @MobX.observable
    public dob: Date = new Date();

    @MobX.observable
    public saveAddress: boolean = false;

    public fromDto = (model: RegisterUserDetailsModel) => {};
    public toDto = (model: RegisterUserDetailsModel) => {};
}
